import axios from "axios";
import apiClient from "../apiClient";

const uploadFile = async (UNO_URL, moduleUUID, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(`${UNO_URL}/api/resource/upload/media/${moduleUUID}`, formData, {
      headers: {
        "Content-Type ": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export default {
  uploadFile,
};
